<template>
  <footer>
    <div class="sub_footer">
      <v-row justify="space-between" class="pt-5 pb-6">
        <v-col cols="12" md="auto" sm="12" class="pb-0 pt-1">
          <p class="text-center"><span class="text-uppercase">{{name}}</span> © - v{{appVersion}}</p>
        </v-col>
        <v-col cols="12" md="auto" sm="12" class="pb-0 pt-1">
          <p class="text-center">DESIGN BY INTEGRASOFT - 2022</p>
        </v-col>
      </v-row>
    </div>
  </footer>
</template>
<script>
import { version,name } from '../../package'
export default {
  name: "Footer",
  data() {
    return {
      name: name,
      appVersion: version,
    }
  },
};
</script>
<style lang="scss">
@import "../assets/scss/base";
</style>
